<template>
  <v-row>
    <v-col cols="12" lg="6" class="mr-lg-6">
      <v-row justify="end">
        <v-btn class="ma-2" @click="addOrganization" color="success" small dark>
          new organization
          <v-icon right dark>add</v-icon>
        </v-btn>
      </v-row>
    </v-col>
    <v-col cols="12" lg="6" v-if="organizations.length > 0">
      <v-card>
        <v-treeview
          :items="organizations"
          open-all
          hoverable
          activatable
          color="primary"
          :active.sync="active"
        ></v-treeview>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Organization",
  props: ["me"],
  data() {
    return {
      active: [],
      flatOrganizations: []
    };
  },
  watch: {
    active(val) {
      if (val && val.length > 0) {
        this.$router.push({ name: "AdministrationOrganization", params: { organizationId: val[0] } })
      }
    }
  },
  computed: {
    organizations() {
      return this.flatOrganizations
        ? this.unflatten(this.flatOrganizations)
        : [];
    }
  },
  methods: {
    getOrganizations() {
      this.active = [];
      this.$http
        .get("api/organizations/")
        .then(request => {
          this.flatOrganizations = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1900", e);
        });
    },
    addOrganization() {
      this.flatOrganizations.push({
        name: "",
        id: "00000000-0000-0000-0000-000000000000",
        parentOrganizationId: this.flatOrganizations[0].id
      });
      this.active = ["00000000-0000-0000-0000-000000000000"];
    },
    unflatten(array, parent, tree) {
      var that = this;
      tree = typeof tree !== "undefined" ? tree : [];
      parent = typeof parent !== "undefined" ? parent : { id: null };
      var children = array.filter(child => {
        return child.parentOrganizationId === parent.id;
      });
      if (children.length) {
        if (!parent.id) {
          tree = children;
        } else {
          parent["children"] = children;
        }
        children.forEach(function(child) {
          that.unflatten(array, child);
        });
      } else {
        parent["children"] = [];
      }
      return tree;
    }
  },
  mounted() {
    this.getOrganizations();
  }
};
</script>